export enum CampaignStatusEnum {
    InDefinition,
    Scheduled,
    InProgress,
    Completed,
    Cancelled,
    Closed
}